<template>
  <section class="workingInfo"  id="workingInfo">

    <div class="bgGear bgGear-desktop">
      <img :src="require('./../../assets/gear-02.png')" alt="">
    </div>

    <div class="container">
      <div class="workingInfo__gear">
        <img :src="require('./../../assets/gear-01.png')" alt="">
      </div>
      <h2 class="workingInfo__title block-title">
        {{componentData.heading[lang]}}
      </h2>
      <p class="workingInfo__subtitle">
        {{componentData.tagline1[lang]}}
        <br>{{componentData.tagline2[lang]}}
      </p>
      <ul class="workingInfo__list">
        <li v-for="item in componentData.principles" :key="item.title">
          <span>{{item.title[lang]}}:</span> {{item.description[lang]}}
        </li>
      </ul>
      <div class="workingInfo__questions">

        <div class="bgGear bgGear-mobile">
          <img :src="require('./../../assets/gear-02.png')" alt="">
        </div>

        <div v-for="item in componentData.faq" @click="e => e.currentTarget.classList.toggle('active')" class="siteFaqItem">
          <div class="siteFaqItem__header">
            <div class="siteFaqItem__container siteFaqItem__question">
              <p class="siteFaqItem__title">
                {{item.title[lang]}}
              </p>
              <div class="siteFaqItem__icon">
                <img class="default" :src="require('./../../assets/arrow-to-bottom.png')" alt="">
                <img class="active"  :src="require('./../../assets/stick.png')" alt="">
              </div>
            </div>
          </div>
          <div class="siteFaqItem__content">
            <div class="siteFaqItem__container siteFaqItem__answer">
              <ul>
                <li v-for="feature in item.features">{{feature[lang]}}</li>
              </ul>
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>


</template>

<script>
import portalData from "../../portal.json";
export default {
  name: "WorkingInfo",
  data() {
    return {
      portalData: portalData,
    }
  },
  computed: {
    lang() {
      return this.language;
    },
    componentData() {
      return portalData.WorkingInfo;
    }

  },
  methods: {
  }
}
</script>

<style scoped>
.siteFaq {
  padding: 20px 0 30px 80px;
}
.siteFaq .container {
  max-width: calc(1170px + 20px * 2);
}
.siteFaq__title {
  text-align: center;
}
.siteFaq__wrapper {
  margin-top: 30px;
}
.siteFaqItem__header {
  display: flex;
  min-height: 80px;
  cursor: pointer;
  padding: 10px 0;
}
.siteFaqItem__icon {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  display: flex;
  width: 36px;
}
.siteFaqItem__icon img {
  margin: auto;
}
.siteFaqItem__icon .default {
  width: 24px;
}
.siteFaqItem__icon .active {
  display: none;
  width: 36px;
}
.siteFaqItem.active .siteFaqItem__icon .default {
  display: none;
}
.siteFaqItem.active .siteFaqItem__icon .active {
  display: block;
}
.siteFaqItem__container {
  width: 100%;
  margin: 0 auto;
}
.siteFaqItem__question {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
}
.siteFaqItem__content {
  border-top: 2px solid #697e8a;
}
.siteFaqItem__title {
  font-size: 24px;
  font-family: 'Marvin', sans-serif;
  width: 100%;
  color: #424243;
  font-weight: bolder;
}
.workingInfo__questions .siteFaqItem__title {
  text-align: center;
}
.siteFaqItem__answer {
  font-size: 18px;
  color: #787878;
  font-weight: bold;
  padding-top: 30px;
  display: none;
}
.siteFaqItem.active ~ .siteFaqItem__answer {
  display: block!important;
}
.siteFaqItem__answer ul {
  padding-left: 1em;
}
.siteFaqItem__answer a {
  color: var(--light-blue);
  text-decoration: underline;
}
.siteFaqItem.active .siteFaqItem__answer {
  display: block;
  animation: fadeIn .5s backwards;
}
.workingInfo {
  padding: 50px 0 30px;
  position: relative;
}
.workingInfo .container {
  max-width: calc(970px + 20px * 2);
}
.workingInfo__title {
  text-align: center;
}
.workingInfo__subtitle {
  max-width: 950px;
  width: 100%;
  margin: 40px auto 0;
  font-size: 18px;
  text-align: center;
  font-weight: bold;
}
.workingInfo__questions {
  margin-top: 70px;
  position: relative;
}
.workingInfo__list {
  margin: 50px auto 0;
  width: 100%;
  font-size: 18px;
  display: flex;
  flex-direction: column;
  gap: 28px;
  padding-left: 1em;
}
.workingInfo__list li {
  display: list-item;
  list-style-type: disc;
  color: #787878;
  font-weight: bold;
}
.workingInfo__list li span {
  color: var(--text-color);
}
.bgGear {
  max-width: 17.188vw;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  transform: translate(-30%, 50%);
}
.bgGear img {
  width: 100%;
}
.workingInfo__gear {
  max-width: 3.646vw;
  width: 100%;
  position: absolute;
  right: 54px;
  top: 110px;
}
.workingInfo__gear img {
  width: 100%;
}

.bgGear-mobile {
  display: none;
}
.bgGear-desktop {
  display: block;
}
@media screen and (max-width: 768px) {
  .bgGear-mobile {
    display: block;
  }
  .bgGear-desktop {
    display: none;
  }
  .siteFaqItem__title {
    font-size: 20px;
    width: 90%;
  }
}
</style>